var DbHelper, W, appUtils, convertToList, createTag, generateGUID, getCleanCodeLabel, getCodeLabel, getGrouppedTagsFromQuestion, includedTagAdder, includedTagRemover, moveIncludedTag, prepareTags, removeIncludedTag, searchCode, stripHTML, updateIncludedTag;

appUtils = require('lib/app_utils');

DbHelper = require('base/lib/db_helper');

generateGUID = require('base/lib/utils').generateGUID;

W = require('when/when');

prepareTags = function(tags) {
  return _.map(tags, function(tag) {
    return {
      id: generateGUID(),
      codes: {},
      name: '',
      type: tag,
      included: true
    };
  });
};

createTag = function(id, tagKey, question) {
  var qTagKey;
  if (question == null) {
    question = null;
  }
  qTagKey = (function() {
    switch (tagKey) {
      case 'population':
        return 'healthProblemOrPopulation';
      default:
        return tagKey;
    }
  })();
  return Immutable.fromJS({
    id: id,
    name: question ? question.get(qTagKey, "") : "",
    questionId: question ? question.get('questionId') : null,
    included: true,
    codes: {},
    type: tagKey
  });
};

includedTagAdder = function(question, tagKey) {
  return function(tags) {
    if (tags == null) {
      tags = Immutable.List();
    }
    return tags.push(createTag(generateGUID(), tagKey, question));
  };
};

includedTagRemover = function(questionId) {
  return function(tags) {
    if (tags == null) {
      tags = Immutable.List();
    }
    return tags.filter(function(tag) {
      return tag.get('questionId') !== questionId;
    });
  };
};

removeIncludedTag = function(tag) {
  return function(tags) {
    if (tags == null) {
      tags = Immutable.List();
    }
    return tags.filterNot(function(t) {
      return t.get('id') === tag.get('id');
    });
  };
};

moveIncludedTag = function(_arg) {
  var dragIndex, hoverIndex;
  dragIndex = _arg.dragIndex, hoverIndex = _arg.hoverIndex;
  return function(tags) {
    var movedTag;
    if (tags == null) {
      tags = Immutable.List();
    }
    if (!((0 <= dragIndex && dragIndex < tags.size))) {
      return tags;
    }
    if (!((0 <= hoverIndex && hoverIndex < tags.size))) {
      return tags;
    }
    movedTag = tags.get(dragIndex);
    if (movedTag == null) {
      return tags;
    }
    return tags["delete"](dragIndex).insert(hoverIndex, movedTag);
  };
};

updateIncludedTag = function(tag) {
  return function(tags) {
    var tagIndex;
    if (tags == null) {
      tags = Immutable.List();
    }
    tagIndex = tags.findIndex(function(t) {
      return t.get('id') === tag.get('id');
    });
    if (tagIndex === -1) {
      return tags;
    }
    return tags.set(tagIndex, tag);
  };
};

getGrouppedTagsFromQuestion = function(question) {
  return question.get('includedTags', Immutable.List()).groupBy(function(tag) {
    return tag.get('type');
  });
};

searchCode = function(field, searchQuery, startAt, limitAt, sorting, options) {
  var abortRequest, request, signal;
  if (startAt == null) {
    startAt = 0;
  }
  if (limitAt == null) {
    limitAt = null;
  }
  if (sorting == null) {
    sorting = 'regular';
  }
  if (options == null) {
    options = {};
  }
  request = $.ajax({
    type: 'POST',
    data: JSON.stringify({
      field: field,
      searchQuery: searchQuery,
      startAt: startAt,
      limitAt: limitAt,
      sorting: sorting
    }),
    contentType: 'application/json',
    xhrFields: {
      withCredentials: true
    },
    url: "" + (DbHelper.getBackendUrl()) + "/dbep/_codes/_search"
  });
  signal = options.signal;
  abortRequest = null;
  if (signal != null) {
    abortRequest = function() {
      return request.abort();
    };
    if (signal.aborted) {
      abortRequest();
    } else {
      if (typeof signal.addEventListener === "function") {
        signal.addEventListener('abort', abortRequest, {
          once: true
        });
      }
    }
  }
  return W(request)["finally"](function() {
    if (abortRequest != null) {
      return signal != null ? typeof signal.removeEventListener === "function" ? signal.removeEventListener('abort', abortRequest) : void 0 : void 0;
    }
  })["catch"](function(error) {
    if (signal != null ? signal.aborted : void 0) {
      return {
        codes: []
      };
    }
    appUtils.errorHandler(error);
    return {
      codes: []
    };
  });
};

stripHTML = function(str) {
  if (str == null) {
    str = "";
  }
  return str.replace(/<[^>]*>?/gm, '');
};

getCodeLabel = function(code) {
  return "" + (code.get('value')) + " " + (code.get('name'));
};

getCleanCodeLabel = function(code) {
  var label;
  label = stripHTML(code.get('value'));
  if (!_.isEmpty(code.get('name'))) {
    label += " - " + (stripHTML(code.get('name')));
  }
  return label;
};

convertToList = function(tags) {
  if (tags == null) {
    return [];
  }
  if (tags.toArray != null) {
    return tags.toArray();
  }
  if (_.isObject(tags) && !_.isArray(tags)) {
    return _.toArray(tags);
  } else {
    return tags;
  }
};

module.exports = {
  convertToList: convertToList,
  createTag: createTag,
  getCleanCodeLabel: getCleanCodeLabel,
  getCodeLabel: getCodeLabel,
  getGrouppedTagsFromQuestion: getGrouppedTagsFromQuestion,
  includedTagAdder: includedTagAdder,
  includedTagRemover: includedTagRemover,
  moveIncludedTag: moveIncludedTag,
  prepareTags: prepareTags,
  removeIncludedTag: removeIncludedTag,
  searchCode: searchCode,
  stripHTML: stripHTML,
  updateIncludedTag: updateIncludedTag
};
